/**
 * The admin app's Firestore handle — the **named database `studio`**.
 *
 * Getting this wrong is silent: writes land in `(default)`, where the consumer platform
 * lives, and the rules that were supposed to guard them never run. So it happens exactly
 * once, here, over the constant in `@atlas-nook/brand`.
 */

import { FIRESTORE_DATABASE } from '@atlas-nook/brand';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import type { Firestore } from 'firebase/firestore';

import { adminEnv, EMULATOR } from '../env.js';
import { firebaseApp } from '../firebase.js';

let cached: Firestore | null = null;

export function db(): Firestore {
  if (cached === null) {
    cached = getFirestore(firebaseApp(), FIRESTORE_DATABASE);
    if (adminEnv().useEmulator) {
      connectFirestoreEmulator(cached, EMULATOR.firestoreHost, EMULATOR.firestorePort);
    }
  }
  return cached;
}

/** The database this build talks to. Shown in the top bar, so a run is never ambiguous. */
export const DATABASE_NAME = FIRESTORE_DATABASE;
